import { SelectOption } from '@/components/elements/select'
import { Paymethods } from '@/entities/api/paymethods'

export const paymethodsMap: SelectOption[] = [
	{ label: 'Envio gratis', value: Paymethods.free },
	{ label: 'Envio pago', value: Paymethods.pay },
]
